module.exports = __webpack_public_path__ + "static/media/taco-header.0c84ab11.jpg";